import * as React from "react";
import type { SVGProps } from "react";
const SvgPaperclip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.857 7.929v6a2.143 2.143 0 0 0 4.286 0V7.714a4.071 4.071 0 0 0-8.143 0v6.643a6 6 0 1 0 12 0V7.93"
    />
  </svg>
);
export default SvgPaperclip;
